<template>
    <svg fill="none" height="14" style="scale: 1.2" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
        <path clip-rule="evenodd" d="M5 0H4V2H5H12V9V10H14V9V1V0H13H5ZM1 4H0V5V13V14H1H9H10V13V5V4H9H1ZM2 12V6H8V12H2Z"
              fill="#A0AEC0" fill-rule="evenodd"/>
    </svg>
</template>

<script>
export default {
    name: 'ClipBoardSvg.vue',
};
</script>
